<template>
  <!--步骤条-->
  <div class="stepsCom" wzades="展示预约流程与你当前所在的预约步骤" aria-label="展示预约流程与你当前所在的预约步骤">
    <template v-if="(type==1)">
      <el-steps :active="stepActive" finish-status="success">
        <el-step title="选择单位/服务"></el-step>
        <el-step title="选择业务类型"></el-step>
        <el-step title="选择服务大厅"></el-step>
        <el-step title="选择预约时间"></el-step>
        <el-step title="填写基本信息"></el-step>
        <el-step title="预约完成"></el-step>
      </el-steps>
    </template>
    <template v-if="(type==2)">
      <el-steps :active="stepActive" finish-status="success">
        <el-step title="选择服务大厅"></el-step>
        <el-step title="选择单位/服务"></el-step>
        <el-step title="选择业务"></el-step>
        <el-step title="选择预约时间"></el-step>
        <el-step title="填写基本信息"></el-step>
        <el-step title="预约完成"></el-step>
      </el-steps>
    </template>
  </div>
</template>
<script>
export default {
  name: "steps",
  props: ['stepActive', 'type']
}
</script>
<style lang="scss">
.stepsCom {
    // add style--------------
  .el-step__head {
    .el-step__icon {
      width: 36px;
      height: 36px;
      border: 5px solid #fff;
      top: -6px;
    }

    &.is-wait {
      .el-step__icon {
        background: #C0C4CC;
        color: #fff;
      }
    }

    &.is-success {
      .el-step__icon {
        .el-step__icon-inner {
          padding-top: 4px;
          box-sizing: border-box;
          display: inline-block;
          width: 28px;
          height: 26px;
          border-radius: 50%;
          border: 2px solid $main-color;
        }
      }
    }
  }
  // end ------------------
  .el-step__head.is-process {
    border-color: $main-color;
    color: #ffffff;

    .el-step__icon.is-text {
      background: $main-color;
    }
  }

  .el-step__title {
    font-weight: 400 !important;
    line-height: 20px;
    position: relative;
    top: -10px;
    left: 5px;
  }

  .el-step__title.is-process {
    color: $main-color;
    font-size: 16px;
  }

  .el-step__head.is-success {
    border-color: $main-color;
    opacity: 0.3;
    color: $main-color;

    .el-step__line {
      background: $main-color;
    }
  }

  .el-step__title.is-success {
    color: $main-color;
    opacity: 0.3;
  }

  .el-step__main {
    margin-top: 9px;
  }

}
</style>